import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
} from "react";
import MESSAGES from "./Components/hooks/message";
type GameContextType = {
  message: string;
  setMessage: React.Dispatch<React.SetStateAction<string>>;

  guessedWords: string[];
  setGuessesWords: React.Dispatch<React.SetStateAction<string[]>>;

  isHelpPanelOpen: boolean;
  setHelpPanelOpen: React.Dispatch<React.SetStateAction<boolean>>;

  isGameStarted: boolean;
  setGameStarted: React.Dispatch<React.SetStateAction<boolean>>;
};

const GameContext = createContext<GameContextType | undefined>(undefined);

export const GameProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [message, setMessage] = useState<string>(MESSAGES.FIRST_START);// состояние для хранения текущего сообщения
  const [isHelpPanelOpen, setHelpPanelOpen] = useState<boolean>(false);// состояние для управления открытием панели помощи
  const [guessedWords, setGuessesWords] = useState<string[]>([]);// массив угаданных слов
  const [isGameStarted, setGameStarted] = useState<boolean>(false); //запущена ли игра
  return (
    <GameContext.Provider
      value={{
        message,
        setMessage,
        isHelpPanelOpen,
        setHelpPanelOpen,
        guessedWords,
        setGuessesWords,
        isGameStarted,
        setGameStarted,
      }}
    >
      {children}
    </GameContext.Provider>
  );
};

export const useGame = () => {
  const context = useContext(GameContext);
  if (!context) {
    throw new Error("useGame must be used within a GameProvider");
  }
  return context;
};
